import lottie, { type AnimationItem } from 'lottie-web';

export function loadJackpotLottie(
  container: Element | null,
  path: string,
  loop: boolean,
): AnimationItem | null {
  if (!container) return null;
  return lottie.loadAnimation({
    autoplay: false,
    container,
    loop,
    path,
    renderer: 'svg',
  });
}

export function restartJackpotLottie(anim: AnimationItem | null): void {
  if (!anim) return;
  anim.goToAndStop(0, true);
  anim.play();
}

export function stopJackpotLottie(anim: AnimationItem | null): void {
  anim?.stop();
}

export function destroyJackpotLottie(anim: AnimationItem | null): void {
  anim?.destroy();
}
